import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { PALETTE, NIVO_THEME, formatShort } from "@react/projects/chantiers_dashboard/components/palette"

const BillingPlanChart = ({ data, currency }) => {
  const rows = (data || []).map((row) => ({
    month: row.label,
    [I18n.t("contracts_dashboard.billing.planned")]:  row.planned / 100,
    [I18n.t("contracts_dashboard.billing.invoiced")]: row.past ? row.invoiced / 100 : null,
  }))

  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value || 0)

  const keys = [
    I18n.t("contracts_dashboard.billing.planned"),
    I18n.t("contracts_dashboard.billing.invoiced"),
  ]

  return (
    <ChartCard
      icon     = "calendar-check"
      title    = {I18n.t("contracts_dashboard.charts.billing")}
      subtitle = {I18n.t("contracts_dashboard.charts.billing_hint")}
      height   = {320}
      empty    = {rows.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {rows}
        keys         = {keys}
        indexBy      = "month"
        groupMode    = "grouped"
        margin       = {{ top: 20, right: 24, bottom: 54, left: 74 }}
        padding      = {0.24}
        innerPadding = {2}
        colors       = {[PALETTE.indigo, PALETTE.emerald]}
        borderRadius = {2}
        enableLabel  = {false}
        axisLeft     = {{ tickSize: 0, tickPadding: 8, format: (v) => formatShort(v * 100) }}
        axisBottom   = {{ tickSize: 0, tickPadding: 10 }}
        theme        = {NIVO_THEME}
        legends      = {[{
          dataFrom: "keys", anchor: "bottom", direction: "row",
          translateY: 46, itemWidth: 130, itemHeight: 16, symbolSize: 9, symbolShape: "circle",
        }]}
        tooltip = {({ id, value, indexValue }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "7px 11px", fontSize: 11, borderRadius: 6 }}>
            <strong>{indexValue}</strong> · {id} : {money(value)}
          </div>
        )}
      />
    </ChartCard>
  )
}

export default BillingPlanChart
